import React from 'react';
import TimeSelect from '../TimeSelect';

const TimeRange = ({
  className,
  startTime,
  endTime,
  onStartTimeChange,
  onEndTimeChange,
  disabled,
  ariaRequired,
  id,
  viaAddSessionModal,
}) => (
  <div className={className}>
    <label htmlFor="start-time">{t('common.time')} *</label>
    <div className="f-sh-0">
      <TimeSelect
        id="start-time"
        ariaRequired={ariaRequired}
        value={startTime}
        onChange={
          viaAddSessionModal ? onStartTimeChange : e => onStartTimeChange(e, id)
        }
        max={endTime}
        disabled={disabled}
        ariaLabel="start-time"
      />
      <label htmlFor="end-time" className="ml-8 mr-8">
        {t('common.to')}
      </label>
      <TimeSelect
        id="end-time"
        ariaRequired={ariaRequired}
        value={endTime}
        onChange={e => onEndTimeChange(e, id)}
        min={startTime}
        disabled={disabled}
        ariaLabel="end-time"
      />
    </div>
  </div>
);

export default TimeRange;
